<template>
  <b-modal ref="balance-history-ref" hide-footer hide-header>
    <div class="vtd-modal-content">
      <div class="vtd-modal-header mb-1">
        <h5 class="vtd-modal-title">Price &amp; Payment History</h5>
        <button @click="closeModal" type="button" class="close" aria-label="Close">
          <span aria-hidden="true"><i class="material-icons">&#xE5CD;</i></span>
        </button>
      </div>

      <div class="vtd-modal-body-payments">
        <div v-if="flightOnly" :class="{ 'active-dropdown': dropdown }" class="price-heading" @click="handleDropdown">
          <h2>WHAT'S INCLUDED?</h2>
          <div class="toggle" @click="handleDropdown">
            <span v-if="!dropdown" @click="handleDropdown">+</span>
            <span v-else @click="handleDropdown">-</span>
          </div>
        </div>
        <div>
          <div v-if="dropdown" class="included-content">
            <div v-for="(item, index) in costInfo" :key="index" class="price-item-container">
              <div class="price-item">
                <h4>{{ item.title }}</h4>
                <p>{{ item.info }}</p>
                <p>
                  {{ item.cost ? `${currencySymbol}${item.cost}` : "Included" }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div v-if="account" class="price">
          <div class="price-amount-container">
            <div v-if="account.totalDesc" class="price-amount">
              <p class="total-price p-1">
                {{ account.totalDesc }}:
                <strong>{{ numberFormat(account.totalCost) }}</strong>
              </p>
            </div>

            <div class="price-details-container">
              <b-table-simple small responsive>
                <b-thead>
                  <b-tr>
                    <b-th>Payment Schedule</b-th>
                    <b-th>Received</b-th>
                  </b-tr>
                </b-thead>

                <b-tbody>
                  <b-tr v-if="account.paidDesc && account.paidCost">
                    <b-td>{{ account.paidDesc }}</b-td>
                    <b-td>{{ numberFormat(account.paidCost) }}</b-td>
                  </b-tr>
                  <b-tr v-if="account.paidoneDesc && account.paidoneCost">
                    <b-td>{{ account.paidoneDesc }}</b-td>
                    <b-td>{{ numberFormat(account.paidoneCost) }}</b-td>
                  </b-tr>
                </b-tbody>

                <b-tbody v-if="account.npd_payments.length > 0 &&
                  account.npd_payments[0] !== ''
                  ">
                  <b-tr v-for="item in account.npd_payments" :key="item.desc" class="dynamic-npd-rows">
                    <b-td>{{ currencySymbol }}{{ item.npd_amnt }}
                      {{ item.desc }}</b-td>
                    <b-td>{{ currencySymbol }}{{ numberFormat(item.amnt) }}</b-td>
                  </b-tr>
                </b-tbody>

                <b-tbody>
                  <b-tr v-if="account.paidtwoDesc && account.paidtwoCost">
                    <b-td>{{ account.paidtwoDesc }}</b-td>
                    <b-td>{{ account.paidtwoCost }}</b-td>
                  </b-tr>
                </b-tbody>

                <b-tfoot>
                  <b-tr variant="secondary">
                    <b-td>{{ account.balanceDesc }}</b-td>
                    <b-td>{{ numberFormat(account.balanceCost) }}</b-td>
                  </b-tr>
                  <b-tr v-if="account.duebyDesc" variant="secondary">
                    <b-td>{{ account.duebyDesc }}</b-td>
                    <b-td>{{ account.duebyDate }}</b-td>
                  </b-tr>
                </b-tfoot>
              </b-table-simple>
            </div>
          </div>

          <div v-if="summary && summary.length > 0 && summary[0] != ''" class="item-top">
            <b-list-group class="mx-3 mt-4 mb-5">
              <b-list-group-item>
                <div v-b-toggle.payment-history @click="dropDown()">
                  <b-row align-h="between">
                    <b-col class="mt-2">
                      <h5 class="pay-history-heading">Payment History</h5>
                    </b-col>
                    <b-col v-if="!historyDropdown" cols="5" class="text-right">
                      <span class="acc-open">
                        <i class="material-icons">arrow_drop_down</i>
                      </span>
                    </b-col>
                    <b-col v-else cols="5" class="text-right">
                      <span class="acc-open">
                        <i class="material-icons">arrow_drop_up</i>
                      </span>
                    </b-col>
                  </b-row>
                </div>
                <b-collapse id="payment-history" accordion="paymentaccord" role="tabpanel">
                  <b-card bg-variant="white">
                    <div v-for="(receipt, rIndex) in summary" :key="rIndex">
                      <b-badge v-if="receipt.date" variant="info" class="mb-2">
                          <span class="clock-date mb-4 mr-3">{{receipt.date}}</span>
                          <span>
                            <b-icon icon="clock" aria-hidden="true" font-scale="1.2" />
                          </span>
                      </b-badge>
                      
                      <b-card bg-variant="light" border-variant="secondary">
                        <h6>{{ receipt.receivedfrom }}</h6>
                        <h6 v-if="receipt.source !== 'apay' && receipt.source !== 'gpay'">
                          {{ receipt.methodofpayment
                          }}<span> {{ receipt.carddetails }} </span>
                        </h6>
                        <h6 v-if="receipt.source === 'apay' && receipt.source !== 'gpay'">
                          Apple Pay
                        </h6>
                        <h6 v-if="receipt.source !== 'apay' && receipt.source === 'gpay'">
                          Google Pay
                        </h6>
                        <h4 class="mt-4">
                          Amount: {{ bookingInfo.booking_currency
                          }}{{ receipt.amount }}
                        </h4>
                      </b-card>
                      <br />
                    </div>
                  </b-card>
                </b-collapse>
              </b-list-group-item>
            </b-list-group>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      historyDropdown: false,
      dropdown: false,
      flightOnly: false,
    };
  },
  computed: {
    ...mapGetters({
      account: "booking/getAccount",
      bookingInfo: "booking/getBookingInfo",
      costInfo: "booking/getCostInfo",
      currencySymbol: "booking/getCurrency",
      dueDate: "booking/getDueDate",
      fil: "booking/getFil",
      summary: "account/getSummary",
    }),
  },
  mounted() {
    this.isFlightOnly();
  },
  methods: {
    dropDown() {
      this.historyDropdown = !this.historyDropdown;
    },
    async showModal() {
      this.$refs["balance-history-ref"].show();
    },
    closeModal() {
      this.$refs["balance-history-ref"].hide();
    },
    numberFormat(string) {
      // eliminate white space
      let regexString = string.replace(/\£\s*/g, "£");
      // add "," for thousands
      regexString = regexString.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
      return regexString;
    },
    handleDropdown() {
      this.dropdown = !this.dropdown;
    },
    isFlightOnly() {
      if (this.bookingInfo.holiday_type.code === "FO") {
        this.flightOnly = true;
      } else this.flightOnly = false;
    },
  },
};
</script>
<style lang="scss">
@import "./styles.scss";
</style>
